<template>
  <section class="page-section">
        <!-- 筛选 -->
        <div class="filter-region no-margin-top">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="日期：" prop="orderTime" class="auto-width">
                <el-date-picker v-model="filterForm.time" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="time-shortcut">
                <el-button plain @click="getLastFewDays(-7)"
                  :class="{ 'is-active': isActiveShortcut(-7) }">近7天</el-button>
                <el-button plain @click="getLastFewDays(-30)"
                  :class="{ 'is-active': isActiveShortcut(-30) }">近30天</el-button>
              </el-form-item>
              <el-form-item label="代理类型：" prop="companyType">
                <el-select v-model="filterForm.companyType" placeholder="请选择" @change="handleCompanyTypeChange">
                  <el-option label="全部" :value="null"></el-option>
                  <el-option v-for="(row, rowIndex) in companyTypeOptions" :label="row.name" :value="row.value"
                    :key="rowIndex"></el-option>
                </el-select>
              </el-form-item>
              <template v-if="filterForm.companyType !== null">
                <el-form-item :label="filterForm.companyType === 0 ? '公司代理名称：' : '个人代理姓名：'" prop="name"
                  class="auto-width">
                  <el-input v-model="filterForm.name" class="w240" placeholder="请输入"></el-input>
                </el-form-item>
              </template>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>

        <!-- 统计 -->
        <div class="statistics" style="margin-top: 10px">
          <div class="item-row">
            <span class="item">销售总金额：{{ statistics.saleAmount || 0 }}</span>
            <span class="item">销售总笔数：{{ statistics.saleNum || 0 }}</span>
          </div>
          <div class="item-row">
            <span class="item">服务订单总金额：￥{{ statistics.serviceOrderAmount || 0 }}</span>
            <span class="item">服务订单总笔数：{{ statistics.serviceOrderNum || 0 }}</span>
            <span class="item">服务订单公司代理总分佣：￥{{ (statistics.serviceOrderIncome || 0) }}</span>
            <span class="item">服务订单个人代理总分佣：￥{{ (statistics.servicePersonOrderIncome || 0) }}</span>
          </div>
          <div class="item-row">
            <span class="item">商品订单总金额：￥{{ statistics.productOrderAmount || 0 }}</span>
            <span class="item">商品订单总笔数：{{ statistics.productOrderNum || 0 }}</span>
            <span class="item">商品订单公司代理总分佣：￥{{ (statistics.productOrderIncome || 0) }}</span>
            <span class="item">商品订单个人代理总分佣：￥{{ (statistics.productPersonOrderIncome || 0) }}</span>
          </div>
        </div>

        <!-- tabs -->
        <template v-if="filterForm.companyType === null">
          <el-radio-group v-model="tabType" size="small" style="margin-top: 10px" @change="getList">
            <el-radio-button :label="0">公司代理</el-radio-button>
            <el-radio-button :label="1">个人代理</el-radio-button>
          </el-radio-group>
        </template>

        <!-- tabs -->
        <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange" style="margin-top: 10px">
          <el-tab-pane label="服务订单" name="2"></el-tab-pane>
          <el-tab-pane label="商品订单" name="1"></el-tab-pane>
        </el-tabs>

        <!-- tab list -->
        <div class="form-module">
          <div class="module-body">
            <!-- table -->
            <div class="table-region" v-loading="tableLoading">
              <template v-if="tabName == '2'">
                <!-- 服务订单统计 -->
                <div class="statistics default" style="margin-top: 10px">
                  <span class="item">服务订单总金额：￥{{ subStatistics.serviceOrderAmount || 0 }}</span>
                  <span class="item">服务订单总笔数：{{ subStatistics.serviceOrderNum || 0 }}</span>
                  <span class="item">服务订单总收益：￥{{ (subStatistics.serviceOrderIncome || 0) }}</span>
                </div>
              </template>
              <template v-if="tabName == '1'">
                <!-- 商品订单统计 -->
                <div class="statistics default" style="margin-top: 10px">
                  <span class="item">商品订单总金额：￥{{ subStatistics.productOrderAmount || 0 }}</span>
                  <span class="item">商品订单总笔数：{{ subStatistics.productOrderNum || 0 }}</span>
                  <span class="item">商品订单总收益：￥{{ (subStatistics.productOrderIncome || 0) }}</span>
                </div>
              </template>
              <!-- 订单列表 -->
              <el-table size="small" :data="tableData" style="margin-top: 20px">
                <el-table-column label="发放收益">
                  <template slot-scope="scope">
                    <p>+{{ scope.row.income }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="发放时间">
                  <template slot-scope="scope">
                    <p>{{ COMMON.formatDate('2', '-', scope.row.incomeTime) }}</p>
                  </template>
                </el-table-column>
                <el-table-column :label="tabName == '2' ? '项目' : '商品'">
                  <template slot-scope="scope">
                    <p style="white-space: pre-line">{{ scope.row.item }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="订单号">
                  <template slot-scope="scope">
                    <p>{{ scope.row.orderNumber }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="订单金额">
                  <template slot-scope="scope">
                    <p>{{ scope.row.orderAmount }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="订单成交时间">
                  <template slot-scope="scope">
                    <p>{{ COMMON.formatDate('2', '-', scope.row.orderCompletionTime) }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="下级顾客">
                  <template slot-scope="scope">
                    <p>{{ scope.row.subCustomer }}<template v-if="scope.row.subCustomerMobile">({{
                      scope.row.subCustomerMobile }})</template>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column label="员工姓名">
                  <template slot-scope="scope">
                    <p>{{ scope.row.employeeName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="table-footer" v-if="page.total > 0">
              <div class="selection-operate"></div>

              <div class="pagination-wrap">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
                  layout="total, sizes, prev, pager, next, jumper" :total="page.total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </section>
</template>

<script>
import {
  COMMON,
  agentOrderStatics,
  agentSaleOrderList
} from '@/common/api';

export default {
  data() {
    return {
      COMMON,

      id: localStorage.getItem('companyId') && localStorage.getItem('companyId') !== 'null' ? localStorage.getItem('companyId') : null,

      filterForm: { // 筛选表单值
        time: [],
        companyType: null,
        name: ''
      },

      companyTypeOptions: [
        {
          value: 0,
          name: '公司'
        },
        {
          value: 1,
          name: '个人'
        }
      ],

      tabType: 0,

      tabName: '2',

      tableData: [],
      tableLoading: false,
      page: { // 分页参数
        current: 1,
        size: 20,
        total: 0
      },

      statistics: {},
      subStatistics: {},

      operatePermission: COMMON.getPermissionStatus(10006) // 用户编辑权限
    }
  },
  methods: {
    /**
     * [filterFormSubmit description] 切换代理类型
     */
    handleCompanyTypeChange() {
      this.filterForm.name = ''
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getList();
          this.getOrderStatics()
        } else {
          return false;
        }
      });
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
      this.tabType = 0
      this.tabName = '2'
      this.page.current = 1;
      this.tableData = [];
      this.getList()
    },
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      this.page.current = 1;
      this.tableData = [];
      this.getList();
    },
    /**
     * [getList description] 获取 tab 列表数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.getOrderList()
      this.getSubOrderStatics()
    },
    /**
     * [getOrderList description] 服务、商品订单列表
     * @return {[type]} [description]
     */
    getOrderList: function (type) {
      this.tableLoading = true;

      const { time, companyType, name } = this.filterForm
      let params = {
        companyType: companyType === null ? this.tabType : companyType,
        type: this.tabName,
        name,
        start: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        end: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : '',
        current: this.page.current,
        size: this.page.size
      }
      if (this.id) {
        params.companyId = this.id
      }

      agentSaleOrderList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.tableData = data.records || [];
          this.tableLoading = false;
          this.page.total = data.total;
          this.$forceUpdate()
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;

      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;

      this.getList();
    },
    /**
     * [isActiveShortcut description] 判断快捷时间是否选中
     * @param  {[Number]} day [description] 近几日
     * @return {[Boolean]}     [description]
     */
    isActiveShortcut(day) {
      if (!this.filterForm.time || this.filterForm.time.length !== 2) return false;
      const start = COMMON.getDay(day);
      const end = COMMON.getDay(0);
      return this.filterForm.time[0] === start && this.filterForm.time[1] === end;
    },
    /**
     * [getLastFewDays description] 获取近几日日期
     * @param  {[Number]} day [description] 需要获取的近几日的数值
     * @return {[type]}        [description]
     */
    getLastFewDays: function (day) {
      this.filterForm.time = [];
      this.filterForm.time.push(COMMON.getDay(day));
      this.filterForm.time.push(COMMON.getDay(0));
    },
    /**
     * [getOrderStatics description] 订单统计
     * @return {[type]} [description]
     */
    getOrderStatics: function () {
      const { time, companyType, name } = this.filterForm
      let params = {
        companyType,
        name,
        start: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        end: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : ''
      }
      if (this.id) {
        params.companyId = this.id
      }

      agentOrderStatics(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          Object.assign(this.statistics, {
            ...data
          })
          this.$forceUpdate()
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [getSubOrderStatics description] 订单统计
     * @return {[type]} [description]
     */
    getSubOrderStatics: function () {
      const { time, companyType, name } = this.filterForm
      let params = {
        companyType: companyType === null ? this.tabType : companyType,
        name,
        start: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        end: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : ''
      }
      if (this.id) {
        params.companyId = this.id
      }

      agentOrderStatics(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          Object.assign(this.subStatistics, {
            ...data
          })
          this.$forceUpdate()
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
  },
  mounted: function () {
    this.getList();
    this.getOrderStatics()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../common/styles/base/_mixin-font';
@import "../../../common/styles/base/mixin-common";

.table-region {
  margin-bottom: 50px;
}

::v-deep .el-radio-group {
  .el-radio-button {
    .el-radio-button__inner {
      padding: 10px 20px;
    }
  }
}

.filter-region {
  flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;

  .filter-form {
    flex: 1;

    .el-form-item {
      &.time-shortcut {
        background: initial;
        padding: 0;

        :deep(.el-form-item__content) {
          width: auto;

          .el-button {
            width: 110px;
            height: 40px;
            border-radius: 5px;

            &.is-active {
              border: 1px solid #3388FF;
              color: #3388FF;
              background-color: #ecf5ff;
            }
          }
        }
      }
    }

    // Remove br forcing line breaks in the flex layout
    br {
      display: none;
    }
  }

  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }
}

.statistics {
  margin-top: -10px;
  padding: 20px;
  background: #EFFAFF;
  border-radius: 4px;
  font-size: 0;

  &.default {
    padding: 10px;
    border: 1px solid #D9D9D9;
    background: transparent;

    .item {
      display: inline;
      width: auto;

      &+.item {
        margin-left: 80px;
      }
    }
  }

  .item {
    display: inline-block;
    width: 240px;
    font-size: 12px;
    color: #222222;
    letter-spacing: 0;
    font-weight: 600;
  }

  .item-row {
    &+.item-row {
      margin-top: 10px;
    }

    .item {
      min-width: 200px;
    }
  }
}

.no-margin-top {
  margin-top: 0;
}

.mr-10 {
  margin-right: 10px;
}

.mr-20 {
  margin-right: 20px;
}

.pt-pb-10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.module-body {
  .text {
    font-size: $smallFS;
    color: $textColor;
    line-height: 27px;
  }

  .avatar {
    position: relative;
    float: left;
    width: 150px;
    height: 150px;
    margin-left: 10px;
    /*background: $colorImgBg;*/

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  .info {
    float: left;
    margin-left: 10px;
  }

  .personal-info-box {
    margin-bottom: 40px;

    .personal-info {
      float: left;
      margin-left: 10px;
    }

    .personal-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }

    .personal-first-avatar-info {
      float: left;
      margin-left: 40px;

      .personal-first-avatar {
        position: relative;
        margin-top: 5px;
        width: 200px;
        height: 130px;
        background: $colorImgBg;

        img {
          max-width: 100%;
          max-height: 100%;
          @include position(absolute, 1, 50%, none, none, 50%);
          @include translate(-50%, -50%, 0);
        }
      }
    }
  }
}
</style>
